

















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Cart } from '@/models/cart';

import ListCart from './ListCart.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

import commonService from '@/services/common-services';
import cartServices from '@/services/cart-services';
import authService from '@/services/auth-services';

import { APP_CONFIG } from '@/config/app-config';

const numeral = require('numeral');


@Component({
    components: {
        Loading,
        ListCart,
        ConfirmModal
    }
})
export default class ConfirmCart extends Vue {
    private feeBuyProRange: any;
    private isUseWallet = false;
    private isCheckPrice = true;
    private isConfirmWallet = false;
    private customerInfo: any = {};
    private isLoading = false;
    private listCart: Cart[] = [];
    private confirmCart: any = {};
    private cartStatus = 0;
    private chinaStoreID = 0;
    private receivePlaceID = 0;
    private isProcessingConfirm = false;
    private lastConfirmPayloadKey = '';

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get param() {
        return this.$route.params.cartIds;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get cartSelected() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].cartSelected;
    }

    get warehouse() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
        return tmp ? tmp.filter(p => p.StoreType === 1 && !p.IsHidden) : null;
    }

    get chinaStore() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
        return tmp ? tmp.filter(p => p.StoreType === 1 && !p.IsHidden) : null;
    }

    get feeGuarantee() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    @Watch('isUseWallet', { deep: true })
    private async watchIsUseWallet() {
        this.isCheckPrice = !this.isUseWallet;
    }

    @Watch('isCheckPrice', { deep: true })
    private async watchIsCheckPrice() {
        this.isUseWallet = !this.isCheckPrice;
    }

    @Watch('customerInfo', { deep: true })
    private async watchCustomerInfo() {
        this.chinaStoreID = this.customerInfo.ChinaStoreID;
        this.receivePlaceID = this.customerInfo.ReceivePlaceID;
    }

    private async onUpdateConfirm(eventData: any) {
        await this.loadData();
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        if (!this.feeGuarantee) {
            await this.getFeeGuarantee();
        }
        await this.getCustomersInfo();
        await this.loadData(true);
    }

    private buildConfirmPayload() {
        const productIds = this.cartSelected.flatMap(cart => cart.products.map(pro => pro.id));
        let otherOptions = [];

        if (this.confirmCart && this.confirmCart.Orders) {
            otherOptions = this.confirmCart.Orders.flatMap(cart => {
                return {
                    'ShopID': cart.OrderShopTempID,
                    'IsFragileGoods': cart.IsFragileGoods,
                    'IsFoam': cart.IsFoam,
                    'IsCheck': cart.IsCheck,
                    'CheckFeeType': cart.CheckFeeType,
                    'IsFast': cart.IsFast,
                    'GuaranteeType': cart.GuaranteeType
                };
            });
        }

        return { productIds, otherOptions };
    }

    private buildConfirmPayloadKey(productIds: number[], otherOptions: any[]) {
        return JSON.stringify({ productIds, otherOptions });
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if (result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData(force = false) {
        if (this.cartSelected === null || this.isProcessingConfirm) {
            if (this.cartSelected === null) this.onComeback();
            return;
        }

        const { productIds, otherOptions } = this.buildConfirmPayload();
        const payloadKey = this.buildConfirmPayloadKey(productIds, otherOptions);

        if (!force && payloadKey === this.lastConfirmPayloadKey) {
            return;
        }

        this.isProcessingConfirm = true;
        this.isLoading = true;

        try {
            const result = await cartServices.cartConfirm(productIds, otherOptions);
            if (result && result.status === 200) {
                this.lastConfirmPayloadKey = payloadKey;
                this.confirmCart = result.data.data;
            }
        } catch (error) {
            console.error("Lỗi khi load data confirm cart:", error);
        } finally {
            this.isLoading = false;
            this.isProcessingConfirm = false;
        }
    }

    private onCloseModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
    }

    private onOtherModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'credit' });
        }
    }

    private onAcceptModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.pushData(false);
        }
    }

    private async submitData() {
        this.cartStatus = 0;
        if (this.isUseWallet === true) {
            if (this.customerInfo.Wallet < this.confirmCart.TotalDeposit) {
                this.isConfirmWallet = true;
                return;
            }
            this.cartStatus = 2;
        }

        this.pushData(this.isUseWallet);
    }

    private async pushData(isDeposit) {
        this.isLoading = true;
        const productIds = this.cartSelected.flatMap(cart => cart.products.map(pro => pro.id));
        const otherOptions = this.confirmCart.Orders.flatMap(cart => { return { 'ShopID': cart.OrderShopTempID, 'IsFragileGoods': cart.IsFragileGoods, 'IsFoam': cart.IsFoam, 'IsCheck': cart.IsCheck, 'CheckFeeType': cart.CheckFeeType, 'IsFast': cart.IsFast, 'GuaranteeType': cart.GuaranteeType } });
        const result = await cartServices.bulk_action(productIds, otherOptions, isDeposit, this.chinaStoreID, this.receivePlaceID);
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            await this.getCustomersInfo();
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: this.cartStatus === 2 ? 'Đơn hàng tạo thành công!' : 'Đơn hàng tạo thành công, vui lòng đặt cọc để mua hàng',
            });
            (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
            this.$router.push({ name: 'order' });
            this.isLoading = false;
        } else {
            this.isLoading = false;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình đặt hàng, vui lòng liên hệ quản trị!',
            });
        }
    }

    private onComeback() {
        this.$router.push({ name: 'cart-index' });
    }
}
